"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedContent = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Page = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"
    /*
    Handles rendering the specified number of items per page for the current page.
    Children array and page references are 0-indexed
     */
])));
var PaginatedContent = function (props) {
    var children = props.children, currPage = props.currPage, itemsPerPage = props.itemsPerPage;
    var displayedContent = children.filter(function (resource) { return resource && resource.key && currPage * itemsPerPage <= resource.key && resource.key <= currPage * itemsPerPage + (itemsPerPage - 1); });
    return react_1.default.createElement(Page, null, displayedContent);
};
exports.PaginatedContent = PaginatedContent;
var templateObject_1;
